export default __webpack_public_path__ + "static/media/redencao_ilustration_large_2.7b47cc2d.jpg";